import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useSignup } from '../hooks/useSignup'
import styles from '../pages/signup/Signup.module.css'

export default function ({openRegister, setOpenRegister}) {

  const handleModalState = () => setOpenRegister(true)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { signup, isPending, error } = useSignup()


  const formatDate = (dateString) => {
    const dateArray = dateString.split('-')
    const day = dateArray[2]
    const month = dateArray[1]
    const year = dateArray[0]
    return `${day}/${month}/${year}`
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    signup(email +'@uob.edu.ly', formatDate(password).replace(/\//g, ''))
  }
  return (
    <div>
   <Modal
        className="comment-modal"
        show={openRegister}
        onHide={() => setOpenRegister(false)}
        >
        <Modal.Header className="btn-close-white" closeButton>
          <Modal.Title className="btn-close-white">تسجيل الطلبة </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form onSubmit={handleSubmit} className={styles['signup-form']}>
       <label>
        <span>الرقم الدراسي:</span>
        <input 
          type="value" 
          onChange={(e) => setEmail(e.target.value)} 
          value={email}
        />
      </label>
      <label>
            <span>تاريخ الميلاد: </span>
            <input
                type="date"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
            />
                {password && <span>تاريخ الميلاد {formatDate(password)}</span>}
        </label>
            { !isPending && <button className="btn btn-light">تسجيل الطالب</button> }
            { isPending && <button className="btn" disabled>loading</button> }
            { error && <p>{error}</p> }
           </form>
        </Modal.Body>
        <Modal.Footer>
        
         
        </Modal.Footer>
      </Modal>

    </div>
  )
}
